// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"52":"476543c8","68":"48f5ba0c","73":"b699fce1","81":"11be8e76","269":"cb1b8318","452":"90641da5"}[chunkId] + ".chunk.js";
};